webpackJsonp([3],{

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils) {
		'use strict';
	
		/**
		 * Leave site button
		 * A plugin that leaves the webpage and remove the browser history of the last visited page.
		 * @exports leaveSiteButton
		 */
		var leaveSiteButton = {
	
			/**
			 * The initialization function for this module.
			 * @param {Object} el - A DOM node.
			 * @public
			 */
			init: function (el) {
				el.setAttribute('target', '');
	
				if (utils.hasHistorySupport()) {
					this._initEvents(el);
				}
			},
	
	
			/**
			 * Init click event, we replace the history of the current page with the startpage.
			 * @param {Object} el - A DOM node.
			 * @private
			 */
			_initEvents: function (el) {
				var maskUrl = '';
	
				// Set maskUrl to webpages homepage.
				try {
					maskUrl = window.location.protocol + '//' + window.location.host;
				} catch (e) {}
	
				utils.addEventListener(el, 'click', function () {
					history.pushState({}, 'Huddinge', maskUrl);
				});
			}
		};
	
	
		return leaveSiteButton;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })

});


// WEBPACK FOOTER //
// partial.3.js